// eslint-disable-next-line import/prefer-default-export
export const routeBase = {
  qa: {
    url: '',
    urlMicroservicesProducts: '',
    urlBusinesses: '',
    apiManagementOrigin: '',
    apiManagementSubscriptionKey: '',
    productsKey: '',
    productsIv: '',
    urlUserManagement: '',
    userManagementApiKey: '',
    userManagementApiIV: '',
    urlMicroservicesOrders: '',
    CONCILIATOR_URL: '',
    CONCILIATOR_USER: '',
    CONCILIATOR_PASSWORD: '',
    marketingCampaign: '',
    MARKETING_CAMPAING_USER: '',
    MARKETING_CAMPAING_PASSWORD: '',
    routeFront: '',
    isMaintenance: 'true',
    routeShopify: {
      url: '',
      SCOrigen: 'qa',
      country: 'co',
      subscriptionId: '',
    },
    coupons: '',
    returns: '',
    sales: '',
    imageProcessor: '',
    imageProcessorApiKey: '',
    PAYMENTS: {
      PAYMENTS_API: '',
      PAYMENTS_OCP_APIM_SUBSCRIPTION_KEY: '',
      PAYMENTS_API_KEY: '',
      SC_ORIGIN: 'Qa',
    },
    TRAVEL: {
      TRAVEL_API: '',
      USER: '',
      PASSWORD: '',
    },
    NOTIFICATION_CONFIGURATOR: '',
    PAYMENT_LINK_BLOB: '',
    PAYMENT_LINK_AUTHORIZATION_KEY: '',
    PAYMENT_ADJUSTER_ENCRYPTION_KEY: '',
    googleApiKey: '',
    integrations: {
      token: '',
      secretKey: '',
    },
    hideReturns: false,
    hideSales: false,
    categorizer: '',
    dashboard: '',
    soat: '',
    soatSubscriptionKey: '',
    payments: '',
    soatApiKey: '',
    soatApiIV: '',
    businessApikey: '',
    cloudflareIp: '',
    CREDINET_URL: '',
    blobTemplateBase: '',
  },
  stag: {
    url: 'https://stg-lpg-dnc-back-apigateway-k8.luegopago.com/sellercenter',
    urlMicroservicesProducts: 'https://api-co-stg.sistecreditocloud.com/Mercurio/Products/v1/Product',
    apiManagementOrigin: 'Stg',
    urlBusinesses: 'https://api-co-stg.sistecreditocloud.com/Mercurio/Authorization/api',
    apiManagementSubscriptionKey: '968ebd48044b4376b3485cf2bc4eb2c6',
    productsKey: '96a527f0cc6549c59d96201efea0c2206cc0b642948aec4e02bc130347fa2087',
    productsIv: '70477bd9e967add3658738b19f4f3859',
    urlUserManagement: 'https://stg-lpg-dnc-back-apigateway-k8.luegopago.com/usermanagement',
    userManagementApiKey: '6ab31013daa1fa9d222d9c21a7d6096f',
    userManagementApiIV: 'a86ab984ff82e7ff',
    urlMicroservicesOrders: 'https://stg-lpg-dnc-back-apigateway-k8.luegopago.com/orders/api/v1/Order',
    CONCILIATOR_URL: 'https://stg-lpg-dnc-back-apigateway-k8.luegopago.com/checkout/api/checkout',
    CONCILIATOR_USER: 'Staging',
    CONCILIATOR_PASSWORD: '2d6afed9-f9f5-483a-a987-c8ae1024d09f',
    marketingCampaign: 'https://stg-lpg-dnc-back-apigateway-k8.luegopago.com/sellermarketing-campaigns',
    MARKETING_CAMPAING_USER: 'Stag',
    MARKETING_CAMPAING_PASSWORD: '2d6afed9-f9f5-483a-a987-c8ae1024d09f',
    routeFront: 'https://stg-luegopago-front-sellercenter.luegopago.com',
    isMaintenance: 'true',
    routeShopify: {
      url: 'https://api.credinet.co/luegopago/integration',
      SCOrigen: 'Staging',
      country: 'co',
      subscriptionId: '',
    },
    coupons: 'https://stg-lpg-dnc-back-apigateway-k8.luegopago.com/api/coupon',
    returns: 'https://stg-lpg-dnc-back-apigateway-k8.luegopago.com/return-orders/api/',
    sales: 'https://stg-lpg-dnc-back-apigateway-k8.luegopago.com/api/sales',
    imageProcessor: 'https://stg-lpg-dnc-back-apigateway-k8.luegopago.com/image-processor/api/Process/ProcessImages',
    imageProcessorApiKey: 'ebcf9b48-1c4c-4409-af03-dc2ee3b8fe76',
    PAYMENTS: {
      PAYMENTS_API: 'https://stg-lpg-dnc-back-apigateway-k8.luegopago.com/payments',
      PAYMENTS_OCP_APIM_SUBSCRIPTION_KEY: '5907e567b3014cef932f84f5bdfbe912',
      PAYMENTS_API_KEY: 'db6e97f3-9d5b-4095-96a4-006c734e3634',
      SC_ORIGIN: 'Staging',
    },
    TRAVEL: {
      TRAVEL_API: 'https://stg-lpg-dnc-back-apigateway-k8.luegopago.com/travel',
      USER: 'front_payment_userService',
      PASSWORD: '8eb4fd96-0fdf-4b0d-a975-997f1d066169',
    },
    PAYMENT_LINK_BLOB: 'https://stocostgmercurio.blob.core.windows.net/frontend/micro-frontends/dist/lgp-ang-paymentadjuster/PaymentAdjuster.js',
    PAYMENT_LINK_AUTHORIZATION_KEY: '02d6299bea5679a8eb3760e238d38308',
    PAYMENT_ADJUSTER_ENCRYPTION_KEY: '8d3f559de29b73d5c4fbb9ce7a1557bf',
    googleApiKey: 'AIzaSyD315GmuVfjOE8CgDEkY_kiYV-JD2RT1DM',
    integrations: {
      token: 'THVlZ29QYWdv.Y2QyMzk2MmQtNTY2Ni00M2MzLWE2NmYtMzMwZmMwMDczODRi',
      secretKey: '',
    },
    hideReturns: false,
    hideSales: false,
    categorizer: 'https://stg-lpg-dnc-back-apigateway-k8.luegopago.com/categorizer',
    dashboard: 'https://luegopago.blob.core.windows.net/luegopago-uploads/ReportsDashboard/STG/dashboard-bundle-iife.js',
    soat: 'https://api-co-stg.sistecreditocloud.com/Luegopago/Soat/v1.0',
    soatSubscriptionKey: '64000e97743945dfa1311ed99dcaaaae',
    payments: 'https://stg-lpg-dnc-back-apigateway-k8.luegopago.com/Payments/api/v2.0',
    soatApiKey: '',
    businessApikey: 'c540beefcb964316b0bdfc2558ab8d03',
    soatApiIV: '',
    cloudflareIp: 'https://www.cloudflare.com/cdn-cgi/trace',
    CREDINET_URL: 'https://stg-can-ang-front-credinetweb.sistecreditocloud.com/login',
    blobTemplateBase: 'https://luegopago.blob.core.windows.net/luegopago-uploads-private',
  },
  prod: {
    url: '',
    urlMicroservicesProducts: '',
    apiManagementOrigin: '',
    urlBusinesses: '',
    apiManagementSubscriptionKey: '',
    productsKey: '',
    productsIv: '',
    urlUserManagement: '',
    userManagementApiKey: '',
    userManagementApiIV: '',
    urlMicroservicesOrders: '',
    CONCILIATOR_URL: '',
    CONCILIATOR_USER: '',
    CONCILIATOR_PASSWORD: '',
    marketingCampaign: '',
    MARKETING_CAMPAING_USER: '',
    MARKETING_CAMPAING_PASSWORD: '',
    routeFront: '',
    isMaintenance: 'true',
    routeShopify: {
      url: '',
      SCOrigen: 'Production',
      country: 'co',
      subscriptionId: '',
    },
    coupons: '',
    returns: '',
    sales: '',
    imageProcessor: '',
    imageProcessorApiKey: '',
    PAYMENTS: {
      PAYMENTS_API: '',
      PAYMENTS_OCP_APIM_SUBSCRIPTION_KEY: '',
      PAYMENTS_API_KEY: '',
      SC_ORIGIN: 'Production',
    },
    TRAVEL: {
      TRAVEL_API: '',
      USER: '',
      PASSWORD: '',
    },
    PAYMENT_LINK_BLOB: '',
    PAYMENT_LINK_AUTHORIZATION_KEY: '',
    PAYMENT_ADJUSTER_ENCRYPTION_KEY: '',
    googleApiKey: '',
    integrations: {
      token: '',
      secretKey: '',
    },
    hideReturns: Boolean('' === 'true'),
    hideSales: Boolean('' === 'true'),
    categorizer: '',
    dashboard: '',
    soat: '',
    soatSubscriptionKey: '',
    payments: '',
    soatApiKey: '',
    businessApikey: '',
    soatApiIV: '',
    cloudflareIp: '',
    CREDINET_URL: '',
    blobTemplateBase: '',
  },

  default: {
    url: 'https://qa-lpg-dnc-back-apigateway-k8.luegopago.com/sellercenter',
    urlMicroservicesProducts:
      'https://api-co-nop-internal.sistecreditocloud.com/products/v1/Product',
    urlBusinesses: 'https://api-co-nop-internal.sistecreditocloud.com/usermanagement/api',
    apiManagementOrigin: 'Qa',
    apiManagementSubscriptionKey: '',
    productsKey: '2341ff8615cbfc09e71b0adf3198f189a51e97c04ea6f3c2e6e2f43990ccf600',
    productsIv: '6252833d1fff0b40821284abbc4169b8',
    urlMicroservicesOrders:
      'https://qa-lpg-dnc-back-apigateway-k8.luegopago.com/orders/api/v1/Order',
    urlUserManagement: 'https://qa-lpg-dnc-back-apigateway-k8.luegopago.com/usermanagement',
    userManagementApiKey: '578b42b7cacd1ab89d732f0c1dee281e',
    userManagementApiIV: '4e6669be389376dc',
    CONCILIATOR_URL: 'http://localhost:3000/api/checkout',
    CONCILIATOR_USER: 'Qa',
    CONCILIATOR_PASSWORD: '2d6afed9-f9f5-483a-a987-c8ae1024d09f',
    marketingCampaign:
      'https://qa-lpg-dnc-back-apigateway-k8.luegopago.com/sellermarketing-campaigns',
    MARKETING_CAMPAING_USER: 'Development',
    MARKETING_CAMPAING_PASSWORD: '2d6afed9-f9f5-483a-a987-c8ae1024d09f',
    routeFront: 'https://qa-luegopago-front-sellercenter.luegopago.com',
    isMaintenance: false,
    routeShopify: {
      url: 'https://qa-luegopago-seller-integration-back-api.luegopago.com',
    },
    coupons: 'https://qa-lpg-dnc-back-apigateway-k8.luegopago.com/api/coupon',
    returns: 'https://qa-lpg-dnc-back-apigateway-k8.luegopago.com/return-orders/api/',
    sales: 'https://qa-lpg-dnc-back-apigateway-k8.luegopago.com/api/sales',
    imageProcessor:
      'https://qa-lpg-dnc-back-apigateway-k8.luegopago.com/image-processor/api/Process/ProcessImages',
    imageProcessorApiKey: 'ebcf9b48-1c4c-4409-af03-dc2ee3b8fe76',
    PAYMENTS: {
      PAYMENTS_API: 'https://devapi.credinet.co/luegopago/pagos',
      PAYMENTS_OCP_APIM_SUBSCRIPTION_KEY: 'b0dc8eb7924540e1913ab262b8500721',
      PAYMENTS_API_KEY: 'd8701b30-3f3d-40d1-896e-df2e8b97abc1',
      SC_ORIGIN: 'Development',
    },
    TRAVEL: {
      TRAVEL_API: 'https://qa-lpg-dnc-back-apigateway-k8.luegopago.com/travel',
      USER: 'Qa',
      PASSWORD: '093970a1-5ce7-47ad-97cf-508cfb42d040',
    },
    NOTIFICATION_CONFIGURATOR:
      'https://luegopago.blob.core.windows.net/luegopago-uploads/NotificationConfigurator/DEV/NotificationConfigurator.js',
    PAYMENT_LINK_BLOB:
      'https://stoconopmercurio.blob.core.windows.net/frontend/micro-frontends/dist/lgp-ang-paymentlink/PaymentAdjuster.js',
    PAYMENT_LINK_AUTHORIZATION_KEY: 'ID_SISTEMA_A',
    PAYMENT_ADJUSTER_ENCRYPTION_KEY: '8d3f559de29b73d5c4fbb9ce7a1557bf',
    googleApiKey: 'AIzaSyD315GmuVfjOE8CgDEkY_kiYV-JD2RT1DM',
    integrations: {
      token: 'THVlZ29QYWdv.Y2QyMzk2MmQtNTY2Ni00M2MzLWE2NmYtMzMwZmMwMDczODRi',
      secretKey: 'AervN2HSP8ay9WYGz3ZAzevvtW',
    },
    hideReturns: false,
    hideSales: false,
    categorizer: 'https://qa-lpg-dnc-back-apigateway-k8.luegopago.com/categorizer',
    dashboard:
      'https://luegopago.blob.core.windows.net/luegopago-uploads/ReportsDashboard/DEV/dashboard-bundle-iife.js',
    soat: 'https://api-co-nop-internal.sistecreditocloud.com/Luegopago/Soat/v1.0',
    soatSubscriptionKey: 'f34d9bb2debf404eb08d9d548f2e4990',
    payments: 'https://qa-lpg-dnc-back-apigateway-k8.luegopago.com/Payments/api/v2.0',
    soatApiKey: '578b42b7cacd1ab89d732f0c1dee281e',
    soatApiIV: '4e6669be389376dc',
    businessApikey: 'e89623a7050047a48c56d764c3d4f1b3',
    cloudflareIp: 'https://www.cloudflare.com/cdn-cgi/trace',
    CREDINET_URL: 'https://aliadoscredinetweb-nop.sistecreditocloud.com/login',
    blobTemplateBase: 'https://luegopago.blob.core.windows.net/luegopago-uploads-private',
  },
}
